const config={
    cognito:{
        REGION: "us-east-2",
        USER_POOL_ID: "us-east-2_Spb0ZplLH",
        APP_CLIENT_ID: "2baa1klacop2l0sa73sac17hd4",
        IDENTITY_POOL_ID: "us-east-2:1ae91a8d-7b8f-4e4a-ab5e-2106516cacf5"
    },
    apiGateway: {
        URL: "https://mvudvcd2r7.execute-api.us-east-2.amazonaws.com/prod/",
        REGION: "us-east-2"
    }
}

export default config;
